<div class="welcome-image"></div>

<h2 class="title">{{ 'INBOX.WELCOME.TITLE' | translate }}</h2>

<ng-container *ngIf="isBusinessApp && !isMultiLocation">
  <p class="subtitle">
    {{ 'INBOX.WELCOME.SUBTITLE' | translate }}
  </p>

  <ul class="next-steps">
    <li *ngIf="displayA2pLink$ | async">
      <a [routerLink]="settingsUrl$ | async">{{ 'INBOX.WELCOME.SMS_REGISTRATION_LINK_TEXT' | translate }}</a>
    </li>
    <li *ngIf="displayFacebookLink$ | async">
      <a [routerLink]="settingsUrl$ | async">{{ 'INBOX.WELCOME.FB_LINK_TEXT' | translate }}</a>
    </li>
    <li *ngIf="displayWebchatLink$ | async">
      <a [routerLink]="settingsUrl$ | async">{{ 'INBOX.WELCOME.WEBCHAT_LINK_TEXT' | translate }}</a>
    </li>
  </ul>
</ng-container>
<ng-container *ngIf="isMultiLocation">
  <p class="subtitle">
    {{ 'INBOX.MULTI_LOCATION.MULTI_LOCATION_SUBTITLE' | translate }}
  </p>
</ng-container>

<p>
  @if (showNewMessage && !isMultiLocation) {
    <button mat-flat-button color="primary" (click)="newMessage()" data-action="clicked-new-message_home">
      {{ 'INBOX.EMPTY.ACTION' | translate }}
    </button>
  }

  <button
    id="optInButton"
    *ngIf="isMultiLocation && (multiLocationEnabled$ | async) === false && !optInClicked"
    mat-flat-button
    color="primary"
    (click)="optIn()"
  >
    {{ 'INBOX.MULTI_LOCATION.MULTI_LOCATION_BUTTON' | translate }}
  </button>
</p>
